if(typeof L === 'undefined') { var e = new Error("Cannot find module 'L'"); e.code = 'MODULE_NOT_FOUND'; throw e; }

module.exports = L;